import { lsFetch } from "helpers/local-storage.helper"

const getAuthorization = (token) => {
  if (token) return `Bearer ${token}`

  const storedToken = lsFetch({ key: "token" })
  if (!storedToken) return null

  return `Bearer ${storedToken}`
}

export default getAuthorization
